import * as React from 'react';

import { SelectProps } from 'antd/es/select';

import ItemsSelect from '@common/react/components/UI/ItemsSelect/ItemsSelect';
import { BaseParams } from '@common/react/objects/BaseParams';

import { SystemAppointmentStatus } from '@commonTuna/react/objects/AppointmentStatus';
import ColorLine from '@commonTuna/react/components/UI/ColorLine/ColorLine';

import { AppointmentStatus, defaultStatusesFilters } from '@app/objects/Appointment';
import { defaultOptions } from '@app/components/UI/AppointmentStatus/defaultOptions';

import '@app/scss/components/statusFilter.scss';

interface LoadStatusesProps {
	value: Array<number> | undefined;
	// eslint-disable-next-line
	onChange: (value: any, option?: any) => void;
	initStatuses?: Array<AppointmentStatus>;
}

interface ComponentProps extends LoadStatusesProps {
	maxTagCount?: number;
	maxTagTextLength?: number;
	allowClear?: boolean;
	antdProps?: SelectProps;
	skipInitLoad?: boolean;
	getPopupContainer?: (node) => HTMLElement;
	additionalOptions?: React.ReactNode;
	additionalFilters?: BaseParams;
	defaultValueIsEmpty?: boolean;
}

interface StatusFilterInnerProps {
	value: Array<number> | undefined;
	// eslint-disable-next-line
	onChange: (value: any) => void;
	statuses: Array<AppointmentStatus>;
}

export const getDefaultStatuses = (statuses: Array<AppointmentStatus>) => {
	return statuses.filter((value) =>
		SystemAppointmentStatus.Canceled !== value.saStatus && SystemAppointmentStatus.Rescheduled !== value.saStatus);
};

const StatusFilterInner: React.FC<StatusFilterInnerProps> = ({ statuses, onChange, value }) => {
	React.useEffect(() => {
		if (!value && statuses.length > 0) {
			onChange(getDefaultStatuses(statuses).map((value) => value.id));
		}
	}, [statuses]);

	return <></>;
};

const StatusFilter: React.FC<ComponentProps> = ({
	value, onChange,
	maxTagCount = 2, maxTagTextLength = 20, allowClear = true, initStatuses, ...rest
}) => {
	const {
		getPopupContainer = ((node) => node.closest('.status-filter') || document.body),
		antdProps,
		additionalOptions,
		additionalFilters,
		defaultValueIsEmpty = false,
	} = rest;

	return (
		<div className="status-filter">
			<ItemsSelect<AppointmentStatus>
				{...defaultOptions}
				items={initStatuses}
				filters={{ ...defaultStatusesFilters, ...additionalFilters }}
				selectProps={{
					mode: 'multiple',
					placeholder: 'Statuses...',
					className: 'w100',
					...antdProps,
					value: value || [],
					onChange,
					maxTagCount,
					maxTagTextLength,
					allowClear,
					getPopupContainer,
					filterOption: (input, option) => (option?.item?.nameEn ?? '').toLowerCase().includes(input.toLowerCase()),
				}}
				itemsProviderSynchronizerProps={{ objectType: 'AppointmentStatusRedux' }}
				additionalOptions={additionalOptions}
				getOptionProps={(item) => ({
					value: item.id,
					children: <div>
						<ColorLine color={item.color} />
						{item.nameEn}
					</div>,
					item,
				})}
			>
				{(state) =>
					(!antdProps || antdProps?.mode === 'multiple') && !defaultValueIsEmpty
					&& <StatusFilterInner value={value} onChange={onChange} statuses={state.items} />}
			</ItemsSelect>
		</div>
	);
};

export default StatusFilter;
